<template>
  <header class="tva-header">
    <div :class="['rows-wrapper', {'expanded' : expanded}]" v-if="$tvaMq !== 'mobile'">
      <div class="tva-first-row">
        <div class="logo">
          <router-link :to="{name: 'home'}">
            <img src="@/assets/images/cane.svg">
          </router-link>
        </div>
        <div class="right-menu">
          <div class="tva-lang-switch">
            <a
              :class="['lang', $ml.current === lang ? 'selected' : '']"
              v-for="lang in $ml.list"
              :key="lang"
              :href="lang === 'IT' ? 'https://www.eni.com/dist/infografiche/eni-for-2018/index.html' : 'https://www.eni.com/dist/infographics/eni-for-2018/index.html'"
            >{{$ml.get("landing")[lang]}}</a>
          </div>
          <span class="share" @click="showSocial = !showSocial">
            <svgicon icon="share" width="14" height="14"></svgicon>
            <div
              :style="{width: !showSocial && $ml.current === 'IT' ? '62px' : !showSocial && $ml.current === 'EN' ? '36px': 0, opacity: showSocial ? 0 : 1}"
              class="share-button"
            >{{$ml.get("landing").condividi}}</div>
          </span>
          <div
            class="social-container"
            :style="{width: showSocial ? '253px' : '0px', transitionDelay: showSocial ? '0s' : '0.5s'}"
          >
            <transition name="fade">
              <div v-show="showSocial === true">
                <social-sharing
                  :url="$ml.get('landing').url"
                  title="Eni for 2018"
                  :description="$ml.get('landing').subtitle"
                  quote
                  hashtags
                  twitter-user
                  inline-template
                >
                  <div class="social-sharing">
                    <network class="socal no-border" network="facebook">Facebook</network>
                    <network network="linkedin">Linkedin</network>
                    <network network="twitter">Twitter</network>
                  </div>
                </social-sharing>
              </div>
            </transition>
          </div>
          <span class="download">
            <router-link :to="{name: 'documents'}">
              <svgicon icon="download-arrow" width="14" height="14"></svgicon>
              {{$ml.get("landing").pubblicazioni}}
            </router-link>
          </span>
        </div>
      </div>
      <div class="tva-second-row" v-if="expanded">
        <ScrollIndicator/>
        <div class="sub-nav">
          <div class="sub-nav-left">
            <router-link :to="{name: 'home'}">
              <div class="circle-icon casina">
                <svgicon icon="casina" width="34" height="34"></svgicon>
              </div>
            </router-link>
            <div class="circle-icon menu" @click="$menuHub.$emit('toggle-menu')">
              <svgicon icon="menu" width="14" height="14"></svgicon>
            </div>
          </div>
          <div class="sub-nav-center">
            <router-link
              v-for="(chapter, chapterIndex) in $ml.get('chapters')"
              :key="'chapter-'+chapterIndex"
              :to="{name: 'chapter', params: {chapterIndex}}"
              class="tva-chapter-nav-button"
            >
              <span :class="{'active' : currentChapter+1 === chapterIndex}">0{{chapterIndex+1}}</span>
              <span :class="{'active' : currentChapter+1 === chapterIndex}">{{chapter.title}}</span>
            </router-link>
          </div>
          <div class="sub-nav-right">
            <svgicon icon="star" width="12" height="12"></svgicon>
            <router-link :to="{name: 'eni_numeri'}">{{$ml.get("landing").eni_numeri}}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="omino" v-if="expanded">
      <svgicon :icon="`omino-${+chapter+1}`" width="50" height="50"></svgicon>
    </div>
    <div v-if="$tvaMq === 'mobile'" class="header-mobile">
      <div class="menu-button-mobile" @click="$menuHub.$emit('toggle-menu')">
        <svgicon icon="menu" width="18" height="18"></svgicon>
      </div>
      <div class="logo-mobile">
        <img src="@/assets/images/cane.svg">
      </div>
    </div>
  </header>
</template>

<script>
import "@/compiled-icons/share";
import "@/compiled-icons/download-arrow";
import "@/compiled-icons/omino-1";
import "@/compiled-icons/omino-2";
import "@/compiled-icons/omino-3";
import "@/compiled-icons/star";
import "@/compiled-icons/menu";
import "@/compiled-icons/casina";
import "@/compiled-icons/freccia";
import "@/compiled-icons/quote1";
import "@/compiled-icons/quote2";
import "@/compiled-icons/play";
import "@/compiled-icons/close-stroke";
import "@/compiled-icons/download-button";
import "@/compiled-icons/pdf-icon";
import ScrollIndicator from "./ScrollIndicator.vue";
export default {
  name: "Header",
  components: {
    ScrollIndicator
  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    chapter: {}
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showSocial: false
    };
  },
  computed: {
    currentChapter() {
      return this.$route.params.chapterIndex - 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/buttons.scss";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.header-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5em 1em;
  width: 100%;
  .logo-mobile {
    width: 110px;
    img {
      width: 100%;
    }
  }
}
.tva-header {
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10;
  display: flex;
  font-family: "Avenir Next";
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  border-bottom: solid 1px $eni-light-grey;
  .share {
    color: $eni-light-grey;
    &:hover {
      font-weight: 600;
      color: black;
      .svg-icon {
        stroke-width: 5px;
      }
    }
  }
  .share-button {
    overflow: hidden;
  }
  .share-button,
  .social-container {
    transition: all 0.5s ease;
    transition-delay: 0s;
  }
  .social-container {
    border-left: solid 1px black;
    padding-left: 0.5em;
  }
  .omino {
    width: 100px;
    flex: 1;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid $eni-light-grey;
    .svg-icon {
      fill: white;
      stroke: $eni-grey;
    }
  }
  .rows-wrapper {
    display: inline-flex;
    flex-direction: column;
    width: 100vw;
    &.expanded {
      width: calc(100vw - 100px);
    }
    .tva-first-row {
      display: flex;
      height: 100%;
      align-items: center;
      .logo img {
        width: 110px;
      }
      display: flex;
      justify-content: space-between;
      padding: 0.5em 2.5em;
      .right-menu {
        display: flex;
        flex-direction: row;
        height: 100%;
        align-items: center;
        .tva-lang-switch {
          .lang {
            position: relative;
            margin-right: 1em;
            color: $eni-grey;
            &:after {
              content: "";
              width: 0;
              height: 100%;
              background: rgba($eni-yellow, 0.5);
              position: absolute;
              top: 0;
              left: 0px;
              z-index: -1;
              transition: all 0.5s ease;
            }
            &:hover {
              color: black;
              &:after {
                width: 100%;
              }
            }
            &.selected {
              color: black;
              font-weight: 700;
            }
          }
        }
        .share,
        .download {
          text-transform: capitalize;
          display: flex;
          align-items: center;
          border-left: 1px solid #4a4a4a;
          padding: 0 0.7em;
          color: black;
          cursor: pointer;
          position: relative;

          a {
            display: flex;
            align-items: center;
            color: black;
          }
          &:after {
            content: "";
            width: 0;
            height: 100%;
            background: rgba($eni-yellow, 0.5);
            position: absolute;
            top: 0;
            left: 0px;
            z-index: -1;
            transition: all 0.5s ease;
          }
          &:hover {
            color: black;
            font-weight: 500;
            &:after {
              width: 100%;
            }
          }
          svg {
            margin-right: 0.5em;
          }
        }
      }
    }
    .tva-second-row {
      .sub-nav {
        padding: 0.6em 2.5em;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .sub-nav-left {
          display: flex;
          .circle-icon {
            border: 1px solid #4a4a4a;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 0.8em;
            cursor: pointer;
            transition: all 0.5s ease;
            &.casina .svg-icon {
              fill: white;
              stroke: #4a4a4a;
            }
            &.menu {
              background: $eni-grey;
              .svg-icon {
                fill: white;
              }
            }
            &:hover {
              background: #4a4a4a;
              .svg-icon {
                stroke: white;
                fill: white;
              }
              &.casina .svg-icon {
                stroke: white;
                fill: #4a4a4a;
              }
            }
          }
        }
        .sub-nav-center {
          a {
            color: inherit;
            text-decoration: unset;
          }
          span:first-child {
            padding-left: 0.5em;
            padding-right: 0.5em;
          }
          span:nth-child(2) {
            padding-left: 0.5em;
            padding-right: 0.5em;
            margin-right: 1em;
            border-left: 1px solid;
            text-transform: uppercase;
            position: relative;
            &:after {
              content: "";
              width: 0;
              height: 100%;
              background: rgba($eni-yellow, 0.5);
              position: absolute;
              top: 0;
              left: 0;
              z-index: -1;
              transition: all 0.5s ease;
            }
            &:hover {
              color: black;
              &:after {
                width: 100%;
              }
            }
            &.active {
              background-color: rgba($eni-yellow, 0.5);
            }
          }
        }
        .sub-nav-right {
          display: flex;
          align-items: center;
          position: relative;
          .svg-icon {
            margin-right: 0.3em;
            position: absolute;
            top: 0;
            left: 7px;
          }
          a {
            text-decoration: none;
            color: black;
            position: relative;
            padding: 0 0.7em 0 1.7em;
            border-left: solid 1px black;
            &:after {
              content: "";
              width: 0;
              height: 100%;
              background: rgba($eni-yellow, 0.5);
              position: absolute;
              top: 0;
              left: 0px;
              z-index: -1;
              transition: all 0.5s ease;
            }

            &:hover {
              color: black;
              &:after {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .tva-header {
    .rows-wrapper {
      width: 100vw !important;
      .tva-second-row {
        .sub-nav-left {
          padding-left: 0.2em !important;
        }
        .sub-nav-center {
          flex-grow: 1;
          padding-left: 2em;
          pointer-events: none;
          span:not(.active) {
            display: none;
          }
          span.active {
            background: transparent !important;
          }
        }
      }
    }
    .omino {
      display: none;
    }
  }
}
</style>
<style lang="scss">
@import "../assets/scss/colors.scss";
@import "../assets/scss/buttons.scss";
.social-sharing {
  display: flex;
  cursor: pointer;
  span {
    padding-left: 0.5em;
    padding-right: 0.5em;
    margin-right: 1em;
    border-left: 1px solid black;
    position: relative;
    &.no-border {
      border-color: transparent !important;
      margin-left: -8px;
    }
    &:after {
      content: "";
      width: 0;
      height: 100%;
      background: rgba($eni-yellow, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      transition: all 0.5s ease;
    }
    &:hover {
      color: black;
      &:after {
        width: 100%;
      }
    }
    &.active {
      background-color: rgba($eni-yellow, 0.5);
    }
  }
}
</style>

